import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "pull-refresh-container"
};
const _hoisted_2 = {
  class: "pulling-container"
};
const _hoisted_3 = {
  class: "status-info"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "status"
};
const _hoisted_6 = {
  class: "pulling-container"
};
const _hoisted_7 = {
  class: "status-info"
};
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = {
  class: "status"
};
const _hoisted_10 = {
  class: "pull-refresh-loading-container"
};
const _hoisted_11 = {
  class: "status-info"
};
const _hoisted_12 = {
  class: "title"
};
const _hoisted_13 = {
  class: "status"
};
import { watch, ref } from 'vue';
import constants from '@/constants';
import { useLess } from '@/models/hooks';
export default {
  __name: 'pullRefresh',
  props: {
    isLoad: {
      type: Boolean,
      required: true
    },
    headHeight: {
      type: Number,
      default: 50
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    animationDuration: {
      type: Number,
      default: () => 500
    }
  },
  emits: ['onRefresh'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    useLess('components/pullRefresh.less');
    const {
      IMAGE_URL
    } = constants;
    const isLoading = ref(false);
    const LOADIMG_URL = `${IMAGE_URL}assets/image/amzLoading.png`;
    const PULL_REFRESH = `${IMAGE_URL}assets/svg/icon/pullRefresh.svg`;
    watch(() => props.isLoad, data => {
      isLoading.value = data;
    });
    const onRefresh = () => emits('onRefresh');
    return (_ctx, _cache) => {
      const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_pull_refresh, {
        modelValue: isLoading.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => isLoading.value = $event),
        disabled: __props.isDisabled,
        "animation-duration": __props.animationDuration,
        onRefresh: onRefresh
      }, {
        pulling: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
          src: LOADIMG_URL,
          alt: "",
          class: "loading"
        }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('modules.commonComponent.pullRefresh.TITLE')), 1), _createElementVNode("div", _hoisted_5, [_createTextVNode(_toDisplayString(_ctx.$t('modules.commonComponent.pullRefresh.PULL_REFRESH')) + " ", 1), _createElementVNode("img", {
          src: PULL_REFRESH,
          alt: "",
          style: _normalizeStyle({
            transform: `rotate(0deg)`
          })
        }, null, 4)])])])]),
        loosing: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
          src: LOADIMG_URL,
          alt: "",
          class: "loading"
        }), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('modules.commonComponent.pullRefresh.TITLE')), 1), _createElementVNode("div", _hoisted_9, [_createTextVNode(_toDisplayString(_ctx.$t('modules.commonComponent.pullRefresh.RELEASE_REFRESH')) + " ", 1), _createElementVNode("img", {
          src: PULL_REFRESH,
          alt: "",
          style: _normalizeStyle({
            transform: `rotate(-180deg)`
          })
        }, null, 4)])])])]),
        loading: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
          src: LOADIMG_URL,
          alt: "",
          class: "pullRefreshImg"
        }), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('modules.commonComponent.pullRefresh.TITLE')), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('modules.commonComponent.pullRefresh.LOADING')), 1)])])]),
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "content")]),
        _: 3
      }, 8, ["modelValue", "disabled", "animation-duration"])]);
    };
  }
};